var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['p-title', _vm.titleClass]},[_c('a',{attrs:{"target":"_blank","href":_vm.product.link}},[_c('h3',{style:([_vm.titleStyles])},[_vm._v(_vm._s(_vm.product.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }